<template>
  <CardSecondary :style="style.card">
    <TextFormLabelPrimary :style="style.label">
      Survey result
    </TextFormLabelPrimary>
    <div :style="style.row">
      <TextRegular :truncate="false">
        Download the workspace-wide survey result.
      </TextRegular>
      <ButtonPrimary @click="downloadSurveyResultFile">
        Download
      </ButtonPrimary>
    </div>
    <div :style="style.placeholder" />
    <div :style="style.row">
      <TextRegular :truncate="false">
        Download the skills framework used in this survey.
      </TextRegular>
      <ButtonPrimary @click="downloadSurveySourceFile">
        Download
      </ButtonPrimary>
    </div>
  </CardSecondary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import CardSecondary from '@modules/v2/card/card-secondary'
  import TextFormLabelPrimary from '@modules/v2/text/text-form-label-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import { Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'AdminSurveyDownload',
    components: {
      ButtonPrimary,
      CardSecondary,
      TextFormLabelPrimary,
      TextRegular,
    },
    props: {
      survey: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          card: {
            height: 'fit-content',
            maxWidth: '560px',
            padding: Layout.space.lg,
            width: '100%',
          },
          label: {
            margin: `0 0 ${Layout.space.sm} 0`,
          },
          placeholder: {
            height: '48px',
          },
          row: {
            display: 'flex',
            height: 'fit-content',
            justifyContent: 'space-between',
            width: '100%',
          },
        },
      };
    },
    computed: {
      ...mapGetters('globalVariables', ['getSurveyDownloadFileModeByKey']),
      ...mapState({
        surveyDownloadFileModes: state => state.globalVariables.data.surveyDownloadFileModes,
      }),
    },
    methods: {
      downloadSurveyResultFile: function () {
        const fileName = (
          `${this.survey.name}_result_${moment().format('MMDDYYYY')}.csv`
        );
        this.$emit(
          'download-file',
          this.getSurveyDownloadFileModeByKey('result').uid,
          fileName,
        );
      },
      downloadSurveySourceFile: function () {
        const fileName = `${this.survey.name}_${moment().format('MMDDYYYY')}.csv`;
        this.$emit(
          'download-file',
          this.getSurveyDownloadFileModeByKey('source').uid,
          fileName,
        );
      },
    },
  };
</script>
